<div class="bg-[#FAFAFA] w-full px-[24px]">
  <div
    class="flex w-full max-w-[1200px] mx-auto flex-col items-start 
            px-[24px] pt-[48px] pb-[32px] gap-[16px] self-stretch 
            sm:py-[60px] sm:pb-[120px] sm:gap-0"
  >
    <!-- Section Header -->
    <div class="flex flex-col items-start gap-4 self-stretch pb-[32px] sm:pb-[80px]">
      <span
        class="text-[#00B884] text-center font-[Manrope] text-[16px] font-medium leading-[17px] tracking-[1px] uppercase"
      >
        {{ 'RECOMMENDED FOR YOU' | translate }}
      </span>
      <h2
        class="self-stretch font-[Manrope] text-[28px] sm:text-[45px] font-bold leading-[36px] sm:leading-[58px] tracking-[-0.9px]"
      >
        {{ 'Product you may be interested' | translate }}
      </h2>
      <span class="w-[100px] h-[5px] rounded-[5px] bg-[#FD71AF] block"></span>
    </div>

    <!-- Cards Section -->
    <div class="w-full relative">
      <!-- ✅ Scrollable wrapper -->
      <div
        #scrollContainer
        class="flex overflow-x-auto scroll-smooth snap-x snap-mandatory scrollbar-hide gap-[16px] sm:gap-[20px] -mx-4 px-4 sm:mx-0 sm:px-0 pb-[10px]"
      >
        <!-- ✅ Cards -->
        <div
          *ngFor="let item of insurances"
          class="snap-start shrink-0 w-[85%] sm:w-[48%] md:w-[31%] lg:w-[31%] flex flex-col rounded-tl-[22px]"
        >
          <!-- Image -->
          <div class="w-full aspect-[4/3] overflow-hidden rounded-tl-[22px]">
            <img
              [src]="item.img"
              [alt]="item.title"
              class="w-full h-full object-cover shadow-[0_6px_12px_0_rgba(0,0,0,0.06)]"
            />
          </div>

          <!-- Content -->
          <div class="flex flex-col flex-1 py-4 justify-between">
            <div>
              <h3
                class="text-[#1B1B1B] font-extrabold text-[18px] sm:text-[22px] leading-normal tracking-[-0.44px] font-[Manrope] mb-[12px] sm:mb-[16px]"
              >
                {{ item.title | translate }}
              </h3>
              <p
                class="text-[#1B1B1B] mb-[12px] sm:mb-[16px] text-[14px] sm:text-[16px] font-normal leading-normal font-[Manrope] line-clamp-2 opacity-80"
              >
                {{ item.description | translate }}
              </p>
            </div>

            <!-- Button -->
            <a
              [href]="item.btnLink"
              target="_blank"
              rel="noopener noreferrer"
              class="flex px-6 py-3 sm:py-4 justify-center items-center rounded-full border border-[#2AD189]
                     text-[#2AD189] font-medium bg-white transition-all duration-400
                     hover:shadow-[2px_4px_4px_#00000040] hover:border-[#2AD189]"
            >
              {{ item.btnText | translate }}
            </a>
          </div>
        </div>
      </div>

      <!-- ✅ Pagination dots (only on mobile) -->
      <div class="flex justify-center mt-4 sm:hidden">
        <div
          *ngFor="let item of insurances; let i = index"
          (click)="setActive(i)"
          class="w-3 h-3 mx-1 rounded-full cursor-pointer transition-all duration-300"
          [ngClass]="activeIndex === i ? 'bg-[#2AD189] scale-110' : 'bg-gray-300'"
        ></div>
      </div>
    </div>
  </div>
</div>
